import { ConversationSummary } from "../../api";
import { Spinner } from "../Spinner";
import styles from "./ConversationSidebar.module.css";

interface Props {
    conversations: ConversationSummary[];
    activeConversationId: string;
    isLoading: boolean;
    onSelect: (conversationId: string) => void;
    onNewChat: () => void;
}

export const ConversationSidebar = ({ conversations, activeConversationId, isLoading, onSelect, onNewChat }: Props) => {
    return (
        <div className={styles.sidebar}>
            <button className={styles.newChatButton} onClick={onNewChat}>
                + New chat
            </button>
            <div className={styles.list}>
                {isLoading ? (
                    <Spinner label="Loading conversations..." />
                ) : conversations.length === 0 ? (
                    <div className={styles.emptyState}>No conversations yet</div>
                ) : (
                    conversations.map(conversation => (
                        <button
                            key={conversation.thread_id}
                            className={`${styles.item} ${conversation.thread_id === activeConversationId ? styles.itemActive : ""}`}
                            title={conversation.title}
                            onClick={() => onSelect(conversation.thread_id)}
                        >
                            {conversation.title || "New conversation"}
                        </button>
                    ))
                )}
            </div>
        </div>
    );
};
